(function () {
  // The header Liquid file defines the mobile menu order directly.
  // Keep only the mobile visual refinements; do not rebuild navigation in JS.
  function mountStyle() {
    if (document.getElementById('aeliza-mobile-reflection-index-style')) return;

    var style = document.createElement('style');
    style.id = 'aeliza-mobile-reflection-index-style';
    style.textContent = [
      '@media (max-width: 900px) {',
      '  .mobile-nav__link--reflection-index { color: #ffffff !important; -webkit-text-fill-color: #ffffff !important; }',
      '  .mobile-nav__subscribe { display: none !important; }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountStyle);
  } else {
    mountStyle();
  }

  document.addEventListener('shopify:section:load', mountStyle);
})();
